module.exports = __webpack_public_path__ + "static/img/swipe-1-1.91a3c42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CloudQuickPrinting/swipe-1-1.png
// module id = Zqgh
// module chunks = 10